export default __webpack_public_path__ + "8e4ccab4685d415922c1fb7a16614c78.svg";